import {Component, Input, OnInit} from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-order-header',
  templateUrl: './order-header.component.html',
  styleUrls: ['./order-header.component.scss']
})
export class OrderHeaderComponent implements OnInit {
  @Input()
  currentOrderData: any;
  @Input()
  bidAndAskPrices: any;
  @Input()
  swapBidAndAskPrices: any;
  @Input()
  actionType: string;
  rebalanceIDDisplayValue:any;
  multiRecords: any = [];
  isSpreadOrder: boolean = false;
  isOption: boolean = false;

  constructor() { 
    
  }

  setRebalanceIDDisplayValue(){
    if(this.currentOrderData){
      if(this.currentOrderData.isImported){
        this.rebalanceIDDisplayValue = this.currentOrderData.rebalanceResultId;
      }else if(this.currentOrderData.isBlockOrder){
      this.rebalanceIDDisplayValue = 'Multiple';
      }else if(this.currentOrderData.rebalanceResultId){
      this.rebalanceIDDisplayValue = this.currentOrderData.rebalanceResultId;
      }else{
        this.rebalanceIDDisplayValue = '';
      }
    }
  }

  ngOnInit(): void {
    if (this.currentOrderData) {
      this.currentOrderData = JSON.parse(JSON.stringify(this.currentOrderData));//its for a deep copy
      if (this.actionType === 'MultiEdit') {
        this.multiRecords = JSON.parse(JSON.stringify(this.currentOrderData));//its for a deep copy
        this.currentOrderData = JSON.parse(JSON.stringify(this.currentOrderData[0])); //its for a deep copy
      } else {
        this.isSpreadOrder = this.currentOrderData.securityType?.toUpperCase() === "OPTION" && this.currentOrderData.optionStrategyType?.toUpperCase() === "SPREAD";
        this.isOption = this.currentOrderData.securityType?.toUpperCase() === "OPTION";
      }
    }
    this.setRebalanceIDDisplayValue();
  }

}
